import { useMask, format } from '@react-input/mask'
import { KTextField, KTextFieldProps } from 'components/core/KTextField'
import {
  ForwardRefExoticComponent,
  RefAttributes,
  forwardRef,
  useEffect,
  useState,
  useMemo,
} from 'react'
import { extractPhoneDigits } from 'utils/phoneUtils'

export const KPhoneField: ForwardRefExoticComponent<
  Omit<KTextFieldProps, 'ref'> & RefAttributes<HTMLDivElement>
> = forwardRef((props, ref) => {
  const { value, onChange, ...restProps } = props
  const [formattedValue, setFormattedValue] = useState('')

  const PHONE_MASK = '(___) ___-____'
  const replacement = useMemo(() => ({ _: /\d/ }), [])

  useEffect(() => {
    if (typeof value === 'string') {
      const digitsOnly = extractPhoneDigits(value)

      if (digitsOnly) {
        try {
          setFormattedValue(
            format(digitsOnly, {
              mask: PHONE_MASK,
              replacement,
            }),
          )
        } catch (error) {
          console.error('Error formatting phone number:', error)
          setFormattedValue('')
        }
      } else {
        setFormattedValue('')
      }
    }
  }, [value, replacement])

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormattedValue(e.target.value)
    onChange?.(e)
  }

  const inputRef = useMask({
    mask: PHONE_MASK,
    replacement,
  })

  return (
    <KTextField
      {...restProps}
      value={formattedValue}
      onChange={handleChange}
      ref={ref}
      inputRef={inputRef}
    />
  )
})
